import React from 'react';

import get from 'lodash/get';

import { SidePage, Section } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import AffiliateDetails from 'scenes/Affiliates/components/AffiliateDetails';
import { ApiIntegrationFormEdit } from 'scenes/ApiIntegrations/components/ApiIntegrationForm';
import {
  useLoadPartnerApiDetails,
  useIsUpdating,
} from 'scenes/ApiIntegrations/data';
import PartnerCompanyDetails from 'scenes/PartnerCompanies/components/PartnerCompanyDetails';

import PartnerApiActions from '../Actions';
import General from './General';
import Metadata from './Metadata';
import RelatedEntities from './RelatedEntities';

const ApiIntegrationDetails = ({ id, onClose, onExited, open }) => {
  const { data, isLoading, isRefetching } = useLoadPartnerApiDetails({ id });

  const [childComponent, openChildComponent] = useChildComponent();
  const isUpdating = useIsUpdating();

  const handleEdit = () => {
    openChildComponent(ApiIntegrationFormEdit, {
      id: data.id,
    });
  };

  const handleDelete = async () => {
    onClose();
  };

  const handleOpenPartnerCompany = (_e, { id }) => {
    openChildComponent(PartnerCompanyDetails, { id });
  };

  const handleOpenAffiliates = (_e, { id }) => {
    openChildComponent(AffiliateDetails, { id });
  };

  const affiliateCount = data?.affiliates?.length || 0;
  const hasAffiliates = !!affiliateCount;
  const hasPartnerCompany = !!data?.partnerCompany;
  const hasRelatedEntities = hasAffiliates || hasPartnerCompany;
  const relatedEntityCount = affiliateCount + (hasPartnerCompany ? 1 : 0);
  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating}
      fetching={isRefetching}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        entityId={id}
        title={'Partner API'}
        subTitle={get(data, 'name')}
      />
      <SidePage.NewBody wrapper={true} dense={true}>
        <SidePage.NewContent>
          <Section title={'General'}>
            <General
              data={data}
              onOpenPartnerCompany={handleOpenPartnerCompany}
              onOpenAffiliate={handleOpenAffiliates}
            />
          </Section>
          <Section
            title={`Related Entities (${relatedEntityCount})`}
            isCollapsable={hasRelatedEntities}
            initialOpen={hasRelatedEntities}
          >
            <RelatedEntities
              data={data}
              hasAffiliates={hasAffiliates}
              hasPartnerCompany={hasPartnerCompany}
            />
          </Section>
        </SidePage.NewContent>
        <SidePage.Sidebar
          actions={
            <PartnerApiActions
              actions={data?.actions}
              data={data}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          }
        >
          <Metadata data={data} />
        </SidePage.Sidebar>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
      {childComponent}
    </SidePage>
  );
};

export default ApiIntegrationDetails;
